/* Actions */
import {
  CLEAR_ALL_NOTIFICATIONS,
  CLEAR_NOTIFICATION,
  SHOW_NOTIFICATION,
  SET_NOTIFICATIONS_ERROR,
  LOAD_CAMPAIGN_NOTIFICATIONS,
  NOTIFICATION_REDUCER_KEY,
} from '@client/redux/notification/notificationReducer';
import { handleApiError } from '@client/redux/reduxUtils/reduxUtils';
import {
  fetchCampaignNotifications,
  putMarkAsRead,
} from '@client/connectivity/api.notifications';

export function showNotification(message = '', notificationType) {
  return function(dispatch) {
    const id = Date.now();
    return dispatch({
      type: SHOW_NOTIFICATION,
      payload: {
        id: id,
        message: message,
        notificationType: notificationType,
      },
    });
  };
}
export function clearNotification(id) {
  return function(dispatch) {
    return dispatch({
      type: CLEAR_NOTIFICATION,
      payload: id,
    });
  };
}
export function clearAllNotifications() {
  return function(dispatch) {
    return dispatch({
      type: CLEAR_ALL_NOTIFICATIONS,
      payload: [],
    });
  };
}

export function loadCampaignNotifications(pageSize = 6, page = 0) {
  return function(dispatch) {
    return fetchCampaignNotifications(pageSize, page)
      .then((response) => {
        return dispatch({
          type: LOAD_CAMPAIGN_NOTIFICATIONS,
          payload: { page, ...response.data },
        });
      })
      .catch((error) => {
        return handleApiError(dispatch, error, SET_NOTIFICATIONS_ERROR);
      });
  };
}

export function putMarkAsReadNotifications(
  notificationIds,
  pageSize = 6,
  page = 0
) {
  return function(dispatch) {
    return putMarkAsRead(notificationIds)
      .then(() => {
        return dispatch(loadCampaignNotifications(pageSize, page));
      })
      .catch((error) => {
        return handleApiError(dispatch, error, SET_NOTIFICATIONS_ERROR);
      });
  };
}

export const selectCampaignNotifications = (state) => {
  return state[NOTIFICATION_REDUCER_KEY].campaignNotifications;
};
